import React, { useEffect } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ProjectChild from '../../atoms/ProjectChild';
import './Project.scss';
import { sound, shoes, momentum, movie } from '../../assets/Assets';

gsap.registerPlugin(ScrollTrigger);
function Project(props) {
  useEffect(() => {
    let tl = gsap.timeline({
      ease: 'power0',
      scrollTrigger: {
        trigger: '.project article',
        start: 'top 75%',
        end: 'bottom 25%',
        toggleActions: 'play',
      },
    });

    tl.from('.project h1', {
      duration: 1,
      y: '-14vw',
    }).from('.projectChild', {
      duration: 1,
      opacity: 0.2,
      y: 40,
      ease: 'power0',
      stagger: {
        from: 'start',
        amount: 1.7,
      },
    });
  }, []);

  return (
    <section className="project">
      <div className="box">
        <h1>
          What I've Done <hr />
        </h1>
      </div>
      <p>
        These are the projects that i've done in my journey. Might not be the
        best, but i really proud of these.
      </p>
      <article className="project-list">
        <ProjectChild
          title="Momentum Clone"
          image={momentum}
          preview="https://finn-momentum.netlify.app"
          source="https://github.com/Finn-AM/MomentumClone"
          rel="noreferrer"
        />
        <ProjectChild
          title="Super Shoes"
          image={shoes}
          preview="https://finn-shoes.netlify.app"
          source="https://github.com/Finn-AM/Shoes"
          rel="noreferrer"
        />
        <ProjectChild
          title="Movies App"
          image={movie}
          preview="https://finn-movies.netlify.app"
          source="https://github.com/Finn-AM/Movie-App"
          rel="noreferrer"
        />
        <ProjectChild
          title="Calming Sound"
          image={sound}
          preview="https://finn-sound.netlify.app"
          source="https://github.com/Finn-AM/Calming-Sound"
          rel="noreferrer"
        />
      </article>
    </section>
  );
}

export default Project;
